import { Component, Input} from '@angular/core';

/**ToDo Documentazione */
@Component({
  selector: 'app-rent-a-car',
  styleUrls: ['./rent-a-car.component.scss'],
  templateUrl: './rent-a-car.component.html'
})
export class RentACarComponent{

  @Input() public days: any;
  @Input() public noImageUrl: any;
  @Input() public defaultImage: any;
  @Input() public version: any;
  @Input() public replaceShowDescriptionButtonWithNotes: boolean = false;
  @Input() public serviceIcons: any;
  
}
